var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUptainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 24,
    viewBox: "0 0 50 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1619",
    "data-name": "Rechteck 1619",
    width: 50,
    height: 24,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_maskieren_1",
    "data-name": "Gruppe maskieren 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uptain_Standardlogo",
    transform: "translate(0 1.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1381",
    "data-name": "Gruppe 1381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1379",
    "data-name": "Gruppe 1379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_658",
    "data-name": "Pfad 658",
    d: "M11.03,3.428,7.993,0,4.958,3.428h1.8V9.582a2.554,2.554,0,0,1-.5,1.768,2.177,2.177,0,0,1-1.655.539,2.13,2.13,0,0,1-1.636-.539,2.551,2.551,0,0,1-.5-1.768l0-5.989A3.33,3.33,0,0,0,0,7.074V9.266a4.9,4.9,0,0,0,1.211,3.523A4.453,4.453,0,0,0,4.6,14.059,4.487,4.487,0,0,0,8,12.788,4.878,4.878,0,0,0,9.216,9.266V3.428h1.812Z",
    fill: "#31b9b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_659",
    "data-name": "Pfad 659",
    d: "M19.418,6.47a4.571,4.571,0,0,0-.848-1.586A3.915,3.915,0,0,0,17.4,4a4.261,4.261,0,0,0-1.186-.421A6.436,6.436,0,0,0,15.2,3.5a4.534,4.534,0,0,0-3.248,1.016A3.253,3.253,0,0,0,10.9,6.946V17.8a3.618,3.618,0,0,0,1.584-.957,3.022,3.022,0,0,0,.878-2.175V13.91a7.755,7.755,0,0,0,1.682.183,4.5,4.5,0,0,0,3.508-1.346,5.533,5.533,0,0,0,1.226-3.858,7.438,7.438,0,0,0-.359-2.416Zm-2.728,5a2.318,2.318,0,0,1-1.816.695,10.958,10.958,0,0,1-1.511-.12V6.714q0-1.1,1.842-1.1a1.746,1.746,0,0,1,1.642.8,5.376,5.376,0,0,1,.47,2.6,3.651,3.651,0,0,1-.626,2.458Z",
    fill: "#31b9b5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_660",
    "data-name": "Pfad 660",
    d: "M22.663,12.746a1.854,1.854,0,0,0,.767.866,3.544,3.544,0,0,0,.87.351,3.5,3.5,0,0,0,.791.089h.05a3.718,3.718,0,0,0,1.24-.221V12.589a2.98,2.98,0,0,1-1.108.205,1.717,1.717,0,0,1-1.206-.339,1.579,1.579,0,0,1-.35-1.156V4.941H26.38V3.723H23.716V.808H22.367V3.724h-1.8V4.942h1.8v6.278a3.542,3.542,0,0,0,.3,1.528Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_661",
    "data-name": "Pfad 661",
    d: "M35.285,12.516a2.96,2.96,0,0,0,.446-1.651v-3.1a4.192,4.192,0,0,0-1.116-3.151,4.538,4.538,0,0,0-3.256-1.074,9.233,9.233,0,0,0-3.024.514V5.345a8.859,8.859,0,0,1,2.943-.464,3.666,3.666,0,0,1,2.3.616,2.48,2.48,0,0,1,.788,2.06v.077l-1.731-.1c-.23,0-.433,0-.6.009s-.462.03-.864.07a7.054,7.054,0,0,0-1.044.172,7.224,7.224,0,0,0-1.009.354,3.217,3.217,0,0,0-.928.573,2.759,2.759,0,0,0-.614.871,2.852,2.852,0,0,0-.25,1.216,3.076,3.076,0,0,0,.32,1.429,2.693,2.693,0,0,0,.772.947,4.107,4.107,0,0,0,1.076.547A5.564,5.564,0,0,0,30.6,14a8.053,8.053,0,0,0,.967.061,6.585,6.585,0,0,0,1.231-.12,6.484,6.484,0,0,0,1.336-.43,2.591,2.591,0,0,0,1.147-.987Zm-3.713.278h-.03c-1.906,0-2.872-.673-2.872-2,0-1.4,1.282-2.111,3.809-2.111a11.123,11.123,0,0,1,1.846.122l.06.01v2.039c0,1.287-.946,1.939-2.812,1.939Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1380",
    "data-name": "Gruppe 1380",
    transform: "translate(37.817 0.251)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1620",
    "data-name": "Rechteck 1620",
    width: 1.349,
    height: 10.169,
    transform: "translate(0.081 3.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1621",
    "data-name": "Rechteck 1621",
    width: 1.51,
    height: 1.51,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_662",
    "data-name": "Pfad 662",
    d: "M47.314,5.092a1.729,1.729,0,0,1,.881.618,2.459,2.459,0,0,1,.362.744,3.054,3.054,0,0,1,.093.791v6.648H50V7.244a3.546,3.546,0,0,0-1.05-2.733,4.243,4.243,0,0,0-2.97-.97,9.642,9.642,0,0,0-4.291.982v9.368h1.349V5.312l.052-.015a9.749,9.749,0,0,1,2.729-.417,4.541,4.541,0,0,1,1.5.211Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_663",
    "data-name": "Pfad 663",
    d: "M14.958,15.8H49.884a.116.116,0,0,1,.116.116v3.489a1.322,1.322,0,0,1-1.321,1.321H14.958a.116.116,0,0,1-.116-.116V15.918a.116.116,0,0,1,.116-.116Z",
    fill: "#31b9b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1382",
    "data-name": "Gruppe 1382",
    transform: "translate(19.075 17.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_664",
    "data-name": "Pfad 664",
    d: "M19.075,17.24h1.491v.411h-.958v.521h.827v.418h-.827v.84h-.532l0-2.191Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_665",
    "data-name": "Pfad 665",
    d: "M21.136,19.191a1.17,1.17,0,0,1-.282-.854,1.184,1.184,0,0,1,.278-.849,1.04,1.04,0,0,1,.79-.29,1.064,1.064,0,0,1,.786.284,1.162,1.162,0,0,1,.283.853,1.191,1.191,0,0,1-.278.851,1.037,1.037,0,0,1-.793.291,1.054,1.054,0,0,1-.785-.286Zm1.176-.314a1.187,1.187,0,0,0,0-1.082.471.471,0,0,0-.392-.163.463.463,0,0,0-.389.164.893.893,0,0,0-.13.545.869.869,0,0,0,.129.537.546.546,0,0,0,.78,0Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_666",
    "data-name": "Pfad 666",
    d: "M24.658,19.434l-.433-.755H23.9v.755h-.532l0-2.191h1.067a.892.892,0,0,1,.585.175.641.641,0,0,1,.206.519.708.708,0,0,1-.119.4.575.575,0,0,1-.328.244l.557.858h-.676Zm-.008-1.471a.328.328,0,0,0-.072-.23.272.272,0,0,0-.21-.079H23.9v.633h.446c.2,0,.306-.108.306-.324Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_667",
    "data-name": "Pfad 667",
    d: "M26.492,18.343q0-1.145,1.078-1.145a1.73,1.73,0,0,1,.7.161v.463a1.119,1.119,0,0,0-.624-.21.574.574,0,0,0-.451.168.848.848,0,0,0-.15.563.815.815,0,0,0,.152.558.612.612,0,0,0,.471.164.942.942,0,0,0,.285-.049,1.309,1.309,0,0,0,.315-.154v.463a1.35,1.35,0,0,1-.328.111,1.689,1.689,0,0,1-.367.042q-1.077,0-1.076-1.137Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_668",
    "data-name": "Pfad 668",
    d: "M28.918,19.29a.842.842,0,0,1-.249-.67V17.247h.556V18.6a.571.571,0,0,0,.1.375.483.483,0,0,0,.644,0,.538.538,0,0,0,.112-.371V17.248h.507v1.373a.857.857,0,0,1-.246.665.953.953,0,0,1-.665.222,1.13,1.13,0,0,1-.758-.218Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_669",
    "data-name": "Pfad 669",
    d: "M31.354,19.451a1.234,1.234,0,0,1-.342-.117v-.506a1.112,1.112,0,0,0,.337.183,1.14,1.14,0,0,0,.369.065c.205,0,.309-.077.309-.233a.176.176,0,0,0-.1-.159,1.8,1.8,0,0,0-.318-.13c-.068-.022-.11-.036-.125-.043a.943.943,0,0,1-.372-.213.54.54,0,0,1-.135-.4.68.68,0,0,1,.092-.347.659.659,0,0,1,.282-.254,1.029,1.029,0,0,1,.47-.094,1.375,1.375,0,0,1,.333.035,1.551,1.551,0,0,1,.3.111v.509a1.482,1.482,0,0,0-.3-.174.783.783,0,0,0-.318-.069.419.419,0,0,0-.232.057.185.185,0,0,0-.087.165.191.191,0,0,0,.052.14.367.367,0,0,0,.129.084c.051.019.134.047.248.082a1.634,1.634,0,0,1,.335.131.58.58,0,0,1,.21.194.565.565,0,0,1,.079.312.714.714,0,0,1-.092.361.651.651,0,0,1-.271.254.894.894,0,0,1-.422.093,2.317,2.317,0,0,1-.433-.035Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_670",
    "data-name": "Pfad 670",
    d: "M33.407,17.661h-.614v-.41h1.77v.411h-.624v1.779h-.532v-1.78Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_671",
    "data-name": "Pfad 671",
    d: "M35.048,19.2a1.17,1.17,0,0,1-.282-.854,1.184,1.184,0,0,1,.278-.849,1.04,1.04,0,0,1,.79-.29,1.064,1.064,0,0,1,.786.284,1.162,1.162,0,0,1,.283.853,1.191,1.191,0,0,1-.278.851,1.04,1.04,0,0,1-.793.291,1.054,1.054,0,0,1-.785-.286Zm1.176-.314a.885.885,0,0,0,.132-.542.876.876,0,0,0-.129-.54.471.471,0,0,0-.392-.163.463.463,0,0,0-.389.164.893.893,0,0,0-.13.545.869.869,0,0,0,.129.537.546.546,0,0,0,.78,0Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_672",
    "data-name": "Pfad 672",
    d: "M39.59,17.257l0,2.19h-.532V17.965l-.644.857-.626-.855v1.478h-.51l0-2.19h.542l.614.855.628-.853h.528Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_673",
    "data-name": "Pfad 673",
    d: "M40.057,17.257h1.5v.411h-.969v.475h.84v.415h-.84v.479h.969v.411h-1.5l0-2.192Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_674",
    "data-name": "Pfad 674",
    d: "M43.3,19.45l-.433-.755h-.328v.755H42l0-2.191h1.067a.892.892,0,0,1,.585.175.641.641,0,0,1,.206.519.716.716,0,0,1-.118.4.575.575,0,0,1-.328.244l.557.858H43.3Zm-.008-1.471a.328.328,0,0,0-.072-.23.272.272,0,0,0-.21-.079h-.47V18.3h.446c.2,0,.306-.108.306-.324Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_675",
    "data-name": "Pfad 675",
    d: "M44.631,19.462a1.234,1.234,0,0,1-.342-.117v-.506a1.112,1.112,0,0,0,.337.183,1.14,1.14,0,0,0,.369.065c.206,0,.309-.077.309-.233a.176.176,0,0,0-.1-.159,1.8,1.8,0,0,0-.318-.13c-.068-.022-.11-.036-.124-.043a.942.942,0,0,1-.372-.213.538.538,0,0,1-.135-.4.68.68,0,0,1,.092-.347.659.659,0,0,1,.282-.254,1.029,1.029,0,0,1,.47-.094,1.375,1.375,0,0,1,.333.035,1.615,1.615,0,0,1,.3.11v.509a1.482,1.482,0,0,0-.3-.174.783.783,0,0,0-.318-.069.419.419,0,0,0-.232.057.185.185,0,0,0-.087.165.191.191,0,0,0,.052.14.367.367,0,0,0,.129.084c.051.019.134.047.248.082a1.634,1.634,0,0,1,.335.131.588.588,0,0,1,.21.194.556.556,0,0,1,.078.312.714.714,0,0,1-.092.361.657.657,0,0,1-.271.254.894.894,0,0,1-.422.093,2.407,2.407,0,0,1-.433-.035Z",
    transform: "translate(-19.075 -17.198)",
    fill: "#efefef"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptainLogo);
export default __webpack_public_path__ + "static/media/uptain_logo.8ab5940b081249f00af205987a89adb7.svg";
export { ForwardRef as ReactComponent };